import { AssetUIModel } from '@thehubz/client/core';

/**
 * Checks if the provided edit type is 'usageRights'
 * @param editType
 * @returns
 */
export function isUsageRightsEdit(editType: string): boolean {
  // Return true if the edit type is 'usageRights'
  return editType === 'usageRights';
}

export function split(input: AssetUIModel[], groupSize: number): AssetUIModel[][] {
  const out = [];
  for (let i = 0; i < input.length; i += groupSize) {
    out.push(input.slice(i, i + groupSize));
  }
  return out;
}

/**
 * Checks if the given key is excluded
 */
export function isExcludedKey(key: string): boolean {
  const excludeKeys = ['buyoutRights', '_id', 'buyoutRightsTitle'];
  return excludeKeys.includes(key);
}
